
import React, { Component } from "react";
import Config from "../../../config";
import { tsDateToThaiDate } from "../../../utils/func";
import { Modal, Button ,Select } from 'antd';
import Datetimepicker from "../../jquery/datetimepicker";

const Option = Select.Option;

class Xpage6ef04dc08 extends Component {
  constructor(props) {
    super(props);
      this.state = { modeLayout1: false, modeLayout2: false, modeLayout3: false, modeLayout4: false, data1: {}, data2: {}, data3: {}, data4: {}, visible2: false, visible3: false, visible4: false, m1:{},m3:[],m4:{},INTERVIEWER_ID:[] };
    let { year ,plt_bld_id } = this.props

    this.getDataLayoutAll(year ,plt_bld_id);
  }

    getDataLayoutAll(year ,plt_bld_id){
        this.getDataLayout1(year ,plt_bld_id)
        this.getDataLayout2(year ,plt_bld_id)
        this.getDataLayout3(year ,plt_bld_id)
        this.getDataLayout4(year ,plt_bld_id)
    }

    getDataLayout1(year ,plt_bld_id){
        let token = localStorage.getItem("ef_token");
        return fetch(Config.api + `/api/getReport-ef04dc07-l1?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}`, {
            headers: {"Content-Type": "application/json",}
            }).then(response => response.json())
            .then(data => {
                if(data.resultCode ==20000 && data.data && data.data.length > 0){
                    this.setState({modeLayout1:'view',data1:data.data[0]});
                }
                console.log("getData1",data);
            }, err => {
            console.log("getData1", err);
        });
    }

    getDataLayout2(year ,plt_bld_id){
        let token = localStorage.getItem("ef_token");
        return fetch(Config.api + `/api/getReport-ef04dc07-l2?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}`, {
            headers: {"Content-Type": "application/json",}
            }).then(response => response.json())
            .then(data => {
                if(data.resultCode ==20000 && data.data && data.data.length > 0){
                    this.setState({modeLayout2:'view',data2:data.data[0]});
                }
                console.log("getData2",data);
            }, err => {
            console.log("getData2", err);
        });
    }

    getDataLayout3(year ,plt_bld_id){
        let token = localStorage.getItem("ef_token");
        return fetch(Config.api + `/api/getReport-ef04dc08-l3?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}`, {
            headers: {"Content-Type": "application/json",}
            }).then(response => response.json())
            .then(data => {
                if(data.resultCode ==20000 && data.data){
                    this.setState({modeLayout3:'view',data3:data.data});
                }
                console.log("getData3",data);
            }, err => {
            console.log("getData3", err);
        });
    }

    getDataLayout4(year ,plt_bld_id){
        let token = localStorage.getItem("ef_token");
        return fetch(Config.api + `/api/getReport-ef04dc08-l4?token=${token}&plt_bld_id=${plt_bld_id}&year=${year}`, {
            headers: {"Content-Type": "application/json",}
            }).then(response => response.json())
            .then(data => {
                if(data.resultCode ==20000 && data.data && data.data.length > 0){
                    this.setState({modeLayout4:'view',data4:data.data[0]});
                }
                console.log("getData4",data);
            }, err => {
            console.log("getData4", err);
        });
    }

    putDataLayout2() {
        let { step, plt_bld_id, year, time } = this.props
        let token = localStorage.getItem("ef_token");
        let { m1 } = this.state
        let data = { ...m1, token, step, plt_bld_id, year, time }
        console.log('data', data)
        return fetch(Config.api + `/api/putReport-ef04dc07-l2`, {
            method: 'PUT', // or 'PUT'
            body: JSON.stringify(data), // data can be `string` or {object}!
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => response.json())
            .then((data) => {
                console.log(data.resultCode)
                if (data.resultCode == 20000) {
                    let { year, plt_bld_id } = this.props
                    this.getDataLayout2(year, plt_bld_id)
                    this.setState({ visible2: false, m2: {} })
                } else {
                    alert('error')
                }
            }, () => {
                alert('error')
            });
    }

    putDataLayout3() {
        let { step, plt_bld_id, year, time } = this.props
        let token = localStorage.getItem("ef_token");
        let { m3 } = this.state
        let data = { data:m3 , token, step, plt_bld_id, year, time }
        console.log('data', data)
        return fetch(Config.api + `/api/putReport-ef04dc08-l3`, {
            method: 'PUT', // or 'PUT'
            body: JSON.stringify(data), // data can be `string` or {object}!
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => response.json())
            .then((data) => {
                console.log(data.resultCode)
                if (data.resultCode == 20000) {
                    let { year, plt_bld_id } = this.props

                    this.setState({ visible3: false, m3: [] })
                    this.getDataLayout3(year, plt_bld_id)
                } else {
                    alert('error')
                }
            }, () => {
                alert('error')
            });
    }

    putDataLayout4() {
        let { step, plt_bld_id, year, time } = this.props
        let token = localStorage.getItem("ef_token");
        let { m4 } = this.state
        let data = { data:m4 , token, step, plt_bld_id, year, time }
        console.log('data', data)
        return fetch(Config.api + `/api/putReport-ef04dc08-l4`, {
            method: 'PUT', // or 'PUT'
            body: JSON.stringify(data), // data can be `string` or {object}!
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => response.json())
            .then((data) => {
                console.log(data.resultCode)
                if (data.resultCode == 20000) {
                    let { year, plt_bld_id } = this.props

                    this.setState({ visible4: false, m4: [] })
                    this.getDataLayout4(year, plt_bld_id)
                } else {
                    alert('error')
                }
            }, () => {
                alert('error')
            });
    }

    getINTERVIEWER_ID(){
        let token = localStorage.getItem("ef_token");
        return fetch(Config.api + `/api/getINTERVIEWER_ID?token=${token}`, {
            headers: {"Content-Type": "application/json",}
            }).then(response => response.json())
            .then(data => {
                if(data.resultCode ==20000 && data.data && data.data.length > 0){
                    this.setState({INTERVIEWER_ID:data.data});
                }
                console.log("getINTERVIEWER_ID",data);
            }, err => {
            console.log("getINTERVIEWER_ID", err);
        });
    }
        Layout1(){
        let { data1,data2 } = this.state
        return <div>
                <h1>แบบกำหนดความรับผิดชอบในการตรวจสอบและรับรองการจัดการพลังงานตามข้อกำหนดวิธีการจดการพลังงานประจำปี {this.props.year}</h1>
                <table style={{borderSpacing:'1px 1px'}}>
                    <tbody>
                        <tr>
                            <th style={{width:'20%'}}>ชื่อโรงงานควบคุม</th>
                            <td style={{width:'80%'}}>{data1.PLT_BLD_NAME}</td>
                        </tr>
                        <tr>
                            <th style={{width:'20%'}}>รหัส TSIC-ID</th>
                            <td style={{width:'80%'}}>{data1.TSIC_ID}</td>
                        </tr>
                        <tr>
                            <th style={{width:'20%'}}>ชื่อนิติบุคคล</th>
                            <td style={{width:'80%'}}>{data1.JURISTIC_NAME}</td>
                        </tr>
                        <tr>
                            <th style={{width:'20%'}}>ที่ตั้งโรงงานควบคุม</th>
                            <td style={{width:'80%'}}>{data1.ADDRESS_NAME}</td>
                        </tr>
                    </tbody>
                </table>
                <table style={{borderSpacing:'1px 1px'}}>
                    <tbody>
                        <tr>
                            <th style={{width:'20%'}}>วันที่ตรวจสอบ ตั้งแต่วันที่</th>
                            <td style={{width:'30%',textAlign:'center'}}>{tsDateToThaiDate(data2.START_D)}</td>
                            <th style={{width:'20%'}}>ถึงวันที่</th>
                        <td style={{ width: '30%', textAlign: 'center' }}>         {tsDateToThaiDate(data2.END_D)}
                        </td>
                    </tr>
                    <tr>
                        <th style={{ width: "20%" }}>
                            ยืนยันการส่งผลการตรวจสอบทางอิเล็กทรอนิกส์แล้วเมื่อวันที่
                  </th>
                        <td colspan="4" style={{ width: "80%" }}>
                            {tsDateToThaiDate(data2.CONFIRM_D)}
                        </td>
                    </tr>
                </tbody>
            </table>
            <span style={{ display: "block", textAlign: "right" }}>
                <ul className="myNavigation">
                    <li>
                        <button type="button" className="myButton1" style={{ verticalAlign: "top", height: "32px" }} onClick={() => {
                            this.setState({ visible2: true, m1: { ...data2 } });
                        }}>
                            <img src="images/iPencil.png" />
                            &nbsp;แก้ไข
                      </button>
                    </li>;
              </ul>
            </span>
                </div>
    }

    Layout3(){
        let { data3 } = this.state
        return <div>
            <h1>รายชื่อผู้ได้รับการสอบถามหรือสัมภาษณ์</h1>
            <table style={{borderSpacing:'1px 1px'}}>
                <tbody>
                    <tr>
                        <th style={{textAlign:'center'}}>ลำดับ</th>
                        <th style={{width:'70%',textAlign:'center'}}>ชื่อ-สกุล</th>
                        <th style={{width:'15%',textAlign:'center'}}>ตำแหน่ง</th>
                        <th style={{width:'15%',textAlign:'center'}}>ลงลายมือชื่อรับรองการถูกสอบถามหรือสัมภาษณ์</th>
                    </tr>
                    {
                        data3.map((d,i)=>{
                        return <tr>
                                <td style={{textAlign:'center'}}>{i+1}</td>
                                <td style={{textAlign:'center'}}>{d.NAME}</td>
                                <td style={{textAlign:'center'}}>{d.POSITION}</td>
                                <td>&nbsp;</td>
                            </tr>
                        })
                    }
                    {
                        Array.apply(0, Array(16)).map((d,i)=>{
                        if(data3.length > i)return null;

                        return <tr>
                                <td style={{textAlign:'center'}}>{i+1}</td>
                                <td style={{textAlign:'center'}}></td>
                                <td style={{textAlign:'center'}}></td>
                                <td>&nbsp;</td>
                            </tr>


                        })
                    }
                </tbody>
            </table>
            <span style={{display:'block', textAlign:'right'}}>
                    <ul className="myNavigation">
                        <li>
                            <button type="button"  className="myButton1" style={{verticalAlign:'top','height':'32px'}}
                              onClick={()=>{this.setState({visible3:true,m3:JSON.parse(JSON.stringify(data3))})}}>
                                <img src="images/iPencil.png"/>&nbsp;แก้ไข
                            </button>
                        </li>
                    </ul>
                </span>
        </div>
    }
    Layout4(){
         let { data4 } = this.state
         let SIGN_1_D = tsDateToThaiDate(data4.SIGN_1_D);
        return <div>
            <br/>
            <div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ขอรับรองว่าข้อความข้างต้นถูกต้อง เป็นจริงทุกประการ</div>
            <br/>
            <table className="MyStyle2">
                <tbody>
                    <tr>
                        <td style={{width:'40%',textAlign:'center'}}> ขื่อผู้สัมภาษณ์ &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{data4.EXPERT_NAME}</td>
                        <td style={{width:'30%',textAlign:'center'}}>ตำแหน่ง&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{data4.EXPERT_POSITION}</td>
                        <td style={{width:'30%',textAlign:'center'}}>วันที่&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{tsDateToThaiDate(data4.INTERVIEW_D)}</td>
                    </tr>
                </tbody>
                </table>
                <span style={{display:'block', textAlign:'right'}}>
                    <ul className="myNavigation">
                        <li>
                            <button type="button"  className="myButton1" style={{verticalAlign:'top','height':'32px'}}
                              onClick={()=>{
                                  this.getINTERVIEWER_ID();
                                  console.log(data4)
                                  this.setState({visible4:true,m4:{...data4}})
                                  }}>
                                <img src="images/iPencil.png"/>&nbsp;แก้ไข
                            </button>
                        </li>
                    </ul>
                </span>
            </div>
    }

    MDLayout2() {
        let { data1, data2, visible2, m1 } = this.state
        console.log(m1);
        return <div>
            <Modal visible={visible2} title="บันทึกข้อมูลระยะเวลาการตรวจสอบ" onOk={() => { }} onCancel={() => {
                this.setState({ visible2: false, m1: {} });
            }} footer={[<Button key="back" onClick={() => {
                this.setState({ visible2: false });
            }}>
                ปิด
                </Button>, <Button key="submit" type="primary" loading={false} onClick={() => {
                this.putDataLayout2();
            }}>
                บันทึกข้อมูล
                </Button>]}>
                <p>บันทึกข้อมูล</p>
                <div>
                    <Datetimepicker name="START_D" value={m1.START_D} onSelect={(value) => {
                        let { m1 } = this.state;
                        m1.START_D = value
                        this.setState({ m1: m1 })
                    }} />
                </div>
                <p>ตรวจเสร็จวันที่</p>
                <div>
                    <Datetimepicker name="END_D" value={m1.END_D} onSelect={(value) => {
                        let { m1 } = this.state;
                        m1.END_D = value;
                        this.setState({ m1: m1 })
                    }} />
                </div>
            </Modal>
        </div>;
    }

    MDLayout3(){
        let { m3 ,visible3 } = this.state
        let listTable = []
        return <div>
               <Modal
                visible={visible3}
                width={900}
                title="บันทึกข้อมูลรายชื่อผู้ให้สัมภาษณ์"
                onOk={()=>{}}
                onCancel={()=>{this.setState({visible3:false})}}
                footer={[
                    <Button key="back" onClick={()=>{this.setState({visible3:false})}}>ปิด</Button>,
                    <Button key="submit" type="primary" loading={false} onClick={()=>{
                        this.putDataLayout3();
                    }}>
                    บันทึกข้อมูล
                    </Button>,
                ]}
                >
                <table style={{borderSpacing:'1px 1px'}}>
                { m3?
                <tbody>
                    <tr>
                        <th style={{width: '100px',textAlign:'center'}}>ลำดับ</th>
                        <th style={{width: '300px',textAlign:'center'}}>ชื่อ-สกุล</th>
                        <th style={{width: '200px',textAlign:'center'}}>ตำแหน่ง</th>
                        <th style={{width: '50px',textAlign:'center'}}>ลบ</th>
                    </tr>
                    {
                        m3.map((d,i)=>{
                        return <tr>
                                <td style={{textAlign:'center'}}>
                                <input type="textbox" value={d.SEQ} size="40" maxlength="80"
                                    onChange={(e)=>{
                                        let { m3 } = this.state;
                                        m3[i].SEQ = e.target.value;
                                        this.setState({ m3: m3 })
                                    }}
                                    style={{width: '100px'}}
                                />
                                </td>
                                <td style={{textAlign:'center'}}>
                                <input type="textbox" value={d.NAME} size="40" maxlength="80"
                                    onChange={(e)=>{
                                        let { m3 } = this.state;
                                        m3[i].NAME = e.target.value;
                                        this.setState({ m3: m3 })
                                    }}
                                />
                                </td>
                                <td style={{textAlign:'center'}}>
                                <input type="textbox" value={d.POSITION} size="40" maxlength="80"
                                    onChange={(e)=>{
                                        let { m3 } = this.state;
                                        m3[i].POSITION = e.target.value;
                                        this.setState({ m3: m3 })
                                    }}
                                />

                                </td>
                                <td style={{textAlign:'center'}}>
                                    <Button key="back" onClick={()=>{
                                        if(window.confirm("คุณต้องการลบ?")){
                                        let { m3 } = this.state;
                                            m3 = m3.filter((r,ii)=>ii!=i)
                                        this.setState({ m3: m3 })
                                        }
                            }}>ลบ</Button>
                                </td>
                            </tr>
                        })
                    }
                    <tr>
                        <td style={{textAlign:'center'}}></td>
                        <td style={{textAlign:'center'}}></td>
                        <td style={{textAlign:'center'}}></td>
                        <td style={{textAlign:'center'}}>
                            <Button key="back" onClick={()=>{
                                        let { m3 } = this.state;
                                        let max = m3.length == 0 ? 0 :Math.max(...m3.map(r=>r.SEQ));
                                        m3.push({
                                            SEQ:   max ? max+1 : 1,
                                            NAME:'',
                                            POSITION:''
                                        })
                                        this.setState({ m3: m3 })
                            }}>เพิ่ม</Button>
                        </td>
                    </tr>
                    </tbody>

                    :null}
                </table>
                </Modal>
            </div>
    }

    MDLayout4(){
        let { data1,data2 ,visible4,m4,INTERVIEWER_ID } = this.state
        return <div>
               <Modal
               width={900}
                visible={visible4}
                title="บันทึกข้อมูลรายชื่อผู้สัมภาษณ์"
                onOk={()=>{}}
                onCancel={()=>{this.setState({visible4:false})}}
                footer={[
                    <Button key="back" onClick={()=>{this.setState({visible4:false})}}>ปิด</Button>,
                    <Button key="submit" type="primary" loading={false} onClick={()=>{
                        this.putDataLayout4();
                    }}>
                    บันทึกข้อมูล
                    </Button>,
                ]}
                >
                <table>
                    <tbody>
				<tr>
					<td>ผู้สัมภาษณ์</td>
                    <td>
                        <Select defaultValue="" style={{ width: 350 }} onChange={(value)=>{
                                    let { m4 } = this.state;
                                        m4.INTERVIEWER_ID = value;
                                        this.setState({ m4: m4 })
                                }} value={m4.INTERVIEWER_ID} >
                            <Option value="">----กรุณาเลือก----</Option>
                            {
                                INTERVIEWER_ID.map((r)=>{
                                    return <Option value={r.PERSON_ID} selected="">{r.PERSON_NAME}</Option>
                                })
                            }
                        </Select>
                    </td>
				</tr>
				<tr>
					<td>วันที่สัมภาษณ์</td>
                    <td>
                         <Datetimepicker name="INTERVIEW_D" value={m4.INTERVIEW_D} onSelect={(value) => {
                        let { m4 } = this.state;
                        m4.INTERVIEW_D = value
                        this.setState({ m4: m4})
                    }}/>
                    </td>
                </tr>
			</tbody>
				</table>
            </Modal>
            </div>
    }

  render() {
     let {modeLayout1 ,modeLayout2 ,modeLayout3 ,modeLayout4 } = this.state

    return <div>
                <div className='myForm-2' style={{minHeight:'530px'}}>
                    {this.MDLayout2()}
                    {this.MDLayout3()}
                    {this.MDLayout4()}
                    {modeLayout1?this.Layout1():null}
                    {modeLayout3?this.Layout3():null}
                    {modeLayout4?this.Layout4():null}
                </div>
          </div>;
  }
}

export default Xpage6ef04dc08;



// WEBPACK FOOTER //
// ./src/view/main/xpage6/ef04dc08.js